import HealthClaims from './HealthClaims';
import DirectClaims from './DirectClaims';
import GlobalClaims from './GlobalClaims';
import GlobalApprovals from './GlobalApprovals';
import ClosedTickets from './ClosedTickets';

export { DirectClaims, GlobalClaims, GlobalApprovals, ClosedTickets };

export default HealthClaims;
